package com.downdogapp

import kotlinx.serialization.json.Json
import kotlin.random.Random

val CAST_APPLICATION_ID = "A4E76589"

infix fun Boolean.implies(other: Boolean) = !this || other

fun Double.toIntIfRound(): Number = toInt().let { if (this == it.toDouble()) it else this }

fun Double.ceil() = kotlin.math.ceil(this).toInt()

fun <T> chooseRandomByWeights(values: Map<T, Double>): T {
  val random = Random.nextDouble() * values.values.sum()
  var sum = 0.0
  for ((value, weight) in values) {
    sum += weight
    if (random < sum) {
      return value
    }
  }
  error("unreachable")
}

fun String.uppercaseFirstChar() = replaceFirstChar { it.uppercaseChar() }

fun String.lowercaseFirstChar() = replaceFirstChar { it.lowercaseChar() }

fun String.toCamelCase() =
  trim()
    .toCapitalCamelCase()
    .lowercaseFirstChar()

fun String.toCapitalCamelCase() =
  if ('_' in this || all { it.isUpperCase() })
    trim()
      .split(' ', '_')
      .joinToString("") {
        it.lowercase().uppercaseFirstChar()
      }
  else
    replaceFirstChar { it.uppercaseChar() }

val JSON = Json {
  encodeDefaults = false
  ignoreUnknownKeys = true
  useArrayPolymorphism = true
}

expect fun Double.toString(decimalPlaces: Int): String
